import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
import { useAppDispatch } from '../../../hooks/hooks';
import { resetRoleData } from '../../../redux/slices/users/role';
import { RootState } from '../../../redux/store';
import { routes } from '../../../routes';
import { createRole } from '../../../services/user/createRole';
import { updateRole } from '../../../services/user/updateRole';
import { RoleType } from '../../../types/Role';
import { Create_Edit_RoleFormValidation } from './Create_Edit_RoleFormValidation';

export const Create_Edit_Role = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const isUpdateRoute = location.pathname === routes.updateRole;

  const dispatch = useAppDispatch();
  const defaultValues = useSelector((state: RootState) => state.role);

  const mutation = useMutation({ mutationFn: ((defaultValues.id && isUpdateRoute) ? updateRole : createRole), mutationKey: "create_edit_Role" });

  const { control, handleSubmit, formState: { errors } } = useForm<RoleType>
    (
      {
        resolver: yupResolver(Create_Edit_RoleFormValidation),
        defaultValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data)
      if (result) {

        toast.success(`Perfil ${(defaultValues.id && isUpdateRoute) ? 'atualizado' : 'registado'}.`);
        handleBack();
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    dispatch(resetRoleData());
    navigate(routes.roles);
  }

  return (
    <Card size='3'>

      <form onSubmit={onSubmit} noValidate>

        <Flex direction='column' gap='4'>
          <Flex gap="8">
            <TextFieldComponent name="role" label='Perfil' control={control} errors={errors} fieldProps={{ placeholder: 'Perfil' }} style={{width: '100%'}} required={true}/>
          </Flex>

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type='button' variant='soft' color='gray' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              {(defaultValues.id && isUpdateRoute) ? 'Atualizar' : 'Registar'}
            </Button>
          </Flex>
        </Flex>
      </form>

    </Card >
  );
};